import { executeQuery, graphql } from '@/lib/query'

import { Locale, USE } from '@config'
import { getLocale } from 'next-intl/server'
import Client from './index.client'

export const query = graphql(/* GraphQL */ `
  query MyQuery($locale: SiteLocale = de) {
    setting(fallbackLocales: de, locale: $locale) {
      cid
      gtm
    }
  }
`)

const Privacy = async () => {
  if (USE.privacy === false) return null
  const locale = (await getLocale()) as Locale
  const { setting } = await executeQuery(query, { variables: { locale } })

  return <Client data={setting} />
}

export default Privacy
